module.exports = __webpack_public_path__ + "media/images/flags/1x1/gbr-2efc46735954635f923af2aa074d18f0.svg";